import React from 'react';
import { ShieldCheckIcon, HeartIcon, BanIcon, CheckIcon, UsersIcon, BookOpenIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function AboutUsPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-370">
      <TopBar data-id="element-371" />
      <Header data-id="element-372" />

      {/* Hero Section */}
      <section className="w-full bg-white py-20 md:py-28 border-b border-gray-200" data-id="element-373">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-374">
          <div className="max-w-4xl mx-auto text-center" data-id="element-375">
            <h1 className="mb-6 text-5xl md:text-6xl font-extrabold text-[#111111] leading-tight" data-id="element-376">
              We're your family's Digital Fiduciary
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-377">
              That means we're legally and ethically bound to put your family's
              interests first—not advertisers, not affiliates, not anyone else.
            </p>
          </div>
        </div>
      </section>

      {/* What is a Digital Fiduciary */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-378">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-379">
          <div className="max-w-4xl mx-auto" data-id="element-380">
            <div className="flex items-center justify-center mb-8" data-id="element-381">
              <div className="w-16 h-16 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center" data-id="element-382">
                <ShieldCheckIcon className="w-8 h-8 text-[#631bb7]" data-id="element-383" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6 text-center" data-id="element-384">
              What is a Digital Fiduciary?
            </h2>
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-200 mb-8" data-id="element-385">
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-386">
                A <strong className="text-[#111111]" data-id="element-387">fiduciary</strong> is
                someone who is legally obligated to act in your best interest.
                Financial advisors, doctors, and lawyers are fiduciaries. They
                can't recommend something just because they get paid more for
                it.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-388">
                A <strong className="text-[#111111]" data-id="element-389">Digital Fiduciary</strong>{' '}
                applies this same standard to technology advice. When we
                recommend a password manager, a privacy setting, or a security
                tool—it's because it's genuinely the best choice for you, not
                because we get a kickback.
              </p>
              <p className="text-xl text-[#111111] font-bold" data-id="element-390">
                Your trust is our product. Not your data. Not your clicks.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Affiliate Bias Ruins Recommendations */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-391">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-392">
          <div className="max-w-4xl mx-auto" data-id="element-393">
            <div className="flex items-center justify-center mb-8" data-id="element-394">
              <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center" data-id="element-395">
                <BanIcon className="w-8 h-8 text-red-500" data-id="element-396" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6 text-center" data-id="element-397">
              Why affiliate bias ruins tech recommendations
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8 text-center" data-id="element-398">
              Most "tech help" sites make money through affiliate links. That
              creates a fundamental conflict of interest.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-399">
              <div className="bg-red-50 rounded-2xl p-6 border-2 border-red-100" data-id="element-400">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-401">
                  How affiliate sites work
                </h3>
                <ul className="space-y-3" data-id="element-402">
                  <li className="flex items-start" data-id="element-403">
                    <span className="text-red-500 mr-2" data-id="element-404">✗</span>
                    <span className="text-gray-600" data-id="element-405">
                      They recommend products that pay the highest commission
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-406">
                    <span className="text-red-500 mr-2" data-id="element-407">✗</span>
                    <span className="text-gray-600" data-id="element-408">
                      They push unnecessary software to increase sales
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-409">
                    <span className="text-red-500 mr-2" data-id="element-410">✗</span>
                    <span className="text-gray-600" data-id="element-411">
                      They create fear to drive purchases
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-412">
                    <span className="text-red-500 mr-2" data-id="element-413">✗</span>
                    <span className="text-gray-600" data-id="element-414">
                      Their "reviews" are really advertisements
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#631bb7] bg-opacity-5 rounded-2xl p-6 border-2 border-[#631bb7] border-opacity-20" data-id="element-415">
                <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-416">
                  How Caveo works
                </h3>
                <ul className="space-y-3" data-id="element-417">
                  <li className="flex items-start" data-id="element-418">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-419" />
                    <span className="text-gray-600" data-id="element-420">
                      We recommend what's actually best for you
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-421">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-422" />
                    <span className="text-gray-600" data-id="element-423">
                      We often recommend free, built-in tools first
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-424">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-425" />
                    <span className="text-gray-600" data-id="element-426">
                      We educate instead of selling fear
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-427">
                    <CheckIcon className="w-5 h-5 text-[#631bb7] mr-2 flex-shrink-0" data-id="element-428" />
                    <span className="text-gray-600" data-id="element-429">
                      Our only revenue is your subscription
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-[#1a0647] rounded-2xl p-8 text-center" data-id="element-430">
              <p className="text-xl text-white font-semibold mb-2" data-id="element-431">
                "If you're not paying for the product, you are the product."
              </p>
              <p className="text-white text-opacity-70" data-id="element-432">
                With Caveo, you're paying for honest guidance. That's it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-433">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-434">
          <div className="max-w-4xl mx-auto text-center" data-id="element-435">
            <div className="flex items-center justify-center mb-8" data-id="element-436">
              <div className="w-16 h-16 bg-[#631bb7] bg-opacity-10 rounded-2xl flex items-center justify-center" data-id="element-437">
                <HeartIcon className="w-8 h-8 text-[#631bb7]" data-id="element-438" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-439">
              Our mission
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-440">
              We believe everyone deserves to feel confident and safe
              online—regardless of age, background, or technical skill.
              Technology should bring families together, not create stress and
              dependency.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-441">
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-442">
                <UsersIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-443" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-444">Family-First</h3>
                <p className="text-gray-600 text-sm" data-id="element-445">
                  Every decision we make considers the whole family—from
                  grandparents to grandkids.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-446">
                <BookOpenIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-447" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-448">
                  Education Over Fear
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-449">
                  We teach skills that last, not sell products that create
                  dependency.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 border-2 border-gray-200" data-id="element-450">
                <ShieldCheckIcon className="w-8 h-8 text-[#631bb7] mx-auto mb-4" data-id="element-451" />
                <h3 className="font-bold text-[#111111] mb-2" data-id="element-452">
                  Radical Honesty
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-453">
                  No affiliate deals. No hidden agendas. Just straight answers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-454">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-455">
          <div className="max-w-3xl mx-auto text-center" data-id="element-456">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-457">
              Ready to experience unbiased guidance?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-458">
              Take your free Family Safety Checkup and see the Caveo difference
              for yourself.
            </p>
            <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-459">
              Get Started
            </Link>
          </div>
        </div>
      </section>

      <Footer data-id="element-460" />
    </div>;
}